var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell-group',[_c('van-cell',{attrs:{"title":"车型","value":_vm.carModelName,"is-link":""},on:{"click":_vm.showSelCarModel}})],1),_c('SelCarModel',{ref:"selCarModel",on:{"pick":_vm.pickCarModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }